import React, { useState } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  Stack,
  Divider,
  Tabs,
  Tab,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  useGetSingleBeauticianQuery,
  useUnlinkAreaMutation,
} from "slices/beautyApp/beauticianSlice";
import { IMAGE_URL } from "network";
import ProfileEdit from "utility/profileEdit";
import EditIcon from "@mui/icons-material/Edit";
import OverviewTab from "./overviewTab";
import DocumentsTab from "./documentsTab";
import ServicesTab from "./servicesTab";
import TimeslotsTab from "./timeslotsTabs";
import BookingsTab from "./bookingsTab";
import WalletTab from "./walletTab";
// Removed Inventory import here since redirecting to separate page
// import Inventory from "./inventory";

function UpdateBeautician() {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data: beautician,
    isSuccess,
    refetch,
  } = useGetSingleBeauticianQuery(id);
  const [del] = useUnlinkAreaMutation();
  const [tab, setTab] = useState(0);
  const [openProfile, setProfile] = useState(false);
  const b = beautician?.data;

  const setProfileClose = () => {
    refetch();
    setProfile(false);
  };

  const handleTabChange = (event, newValue) => {
    if (newValue === 6) {
      navigate(`/beauty-app/beauticians/inventory/${id}`);
    } else {
      setTab(newValue);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ProfileEdit
        open={openProfile}
        data={b?.user}
        usertype={"beautician"}
        onClose={() => setProfileClose()}
      />
      <Box px={3} py={4}>
        <Grid container spacing={3}>
          {/* LEFT PANEL */}
          {/* <Grid item xs={12} md={3}>
            <Card
              sx={{ p: 3, borderRadius: 4, boxShadow: 6, position: "relative" }}
            >
              <EditIcon
                color="primary"
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  cursor: "pointer",
                }}
                onClick={() => setProfile(true)}
              />
              <img
                crossOrigin="anonymous"
                src={IMAGE_URL + b?.user?.image}
                alt={b?.user?.name}
                style={{
                  width: "100px",
                  height: "100px",
                  margin: "0 auto 16px auto",
                  border: "3px solid #fff",
                  boxShadow: "0px 4px 10px rgba(203, 135, 135, 0.2)",
                  borderRadius: "50%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
              <Typography variant="h6" fontWeight={600} align="center">
                {b?.user?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center">
                Beautician
              </Typography>

              <Stack
                direction="row"
                justifyContent="space-around"
                mt={3}
                mb={2}
              >
                <Box textAlign="center">
                  <Typography fontWeight={600}>
                    {b?.user?.followers || 0}
                  </Typography>
                  <Typography variant="caption">Reviews</Typography>
                </Box>
                <Box textAlign="center">
                  <Typography fontWeight={600}>{b?.twets || 0}</Typography>
                  <Typography variant="caption">Bookings</Typography>
                </Box>
              </Stack>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" gutterBottom>
                Bio
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {b?.bio
                  ? b.bio.split(" ").slice(0, 50).join(" ") +
                    (b.bio.split(" ").length > 50 ? "..." : "")
                  : "........"}
              </Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" gutterBottom>
                Skills
              </Typography>
              {b?.user?.specializations?.length > 0 &&
                b?.user?.specializations.slice(0, 7).map((item, i) => (
                  <Typography key={i} variant="body2">
                    {item.name}
                  </Typography>
                ))}
            </Card>
          </Grid> */}
          {/* RIGHT PANEL */}
          <Grid item xs={12}>
            {/* Top stats row */}
            <Grid container spacing={3} mb={4}>
              {/* Profile Details */}
              <Grid item xs={12} md={4}>
                <Card
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                    height: "100%",
                  }}
                >
                  <EditIcon
                    color="primary"
                    sx={{
                      position: "absolute",
                      top: 16,
                      right: 16,
                      cursor: "pointer",
                    }}
                    onClick={() => setProfile(true)}
                  />
                  <Box display="flex" alignItems="center" gap={2} mb={2}>
                    <img
                      crossOrigin="anonymous"
                      src={b?.user?.image ? IMAGE_URL + b.user.image : "/broken-image.jpg"}
                      alt={b?.user?.name || "Beautician"}
                      style={{
                        width: 72,
                        height: 72,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "3px solid #f0e0ef",
                        boxShadow: "0 2px 8px rgba(68,33,65,0.15)",
                        flexShrink: 0,
                      }}
                    />
                    <Box>
                      <Typography variant="h6" fontWeight={700} sx={{ color: "#442141" }}>
                        {b?.user?.name || "N/A"}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">Beautician</Typography>
                    </Box>
                  </Box>
                  <Typography variant="h6" fontWeight={600} mb={2}>
                    Profile Details
                  </Typography>

                  <Stack spacing={1}>
                    <Typography variant="body2">
                      <strong>Email:</strong> {b?.user?.email || "N/A"}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Phone:</strong> {b?.user?.mobile || "N/A"}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Status:</strong>{" "}
                      <span style={{ color: b?.user?.status === "active" ? "#22c55e" : "#ef4444", fontWeight: 600 }}>
                        {b?.user?.status ? b.user.status.charAt(0).toUpperCase() + b.user.status.slice(1) : "N/A"}
                      </span>
                    </Typography>
                  </Stack>
                </Card>
              </Grid>

              {/* Service Completed Section */}
              <Grid item xs={12} md={8}>
                <Card
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                  }}
                >
                  <Typography variant="h6" fontWeight={600} mb={3}>
                    Service Performance
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Card
                        sx={{
                          p: 2,
                          textAlign: "center",
                          borderRadius: 2,
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <Typography
                          variant="h5"
                          fontWeight={600}
                          color="primary"
                        >
                          {b?.orderStats?.totalOrders || 0}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Total Bookings
                        </Typography>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Card
                        sx={{
                          p: 2,
                          textAlign: "center",
                          borderRadius: 2,
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <Typography
                          variant="h5"
                          fontWeight={600}
                          color="warning.main"
                        >
                          {b?.orderStats?.uncompletedOrders || 0}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Pending Services
                        </Typography>
                      </Card>
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <Card
                        sx={{
                          p: 2,
                          textAlign: "center",
                          borderRadius: 2,
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <Typography
                          variant="h5"
                          fontWeight={600}
                          color="success.main"
                        >
                          {b?.orderStats?.completedOrders || 0}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Services Completed
                        </Typography>
                      </Card>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>

            {/* Tabs */}
            <Card sx={{ p: 3, borderRadius: 4, boxShadow: 6 }}>
              <Tabs
                value={tab}
                onChange={handleTabChange}
                sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
              >
                <Tab label="Overview" />
                <Tab label="Documents" />
                <Tab label="Locations & Services" />
                <Tab label="Timeslots" />
                <Tab label="Subscriptions" />
                <Tab label="Wallet" />
                <Tab label="Inventory" />
              </Tabs>
              {tab === 0 && (
                <OverviewTab beautician={b?.user} refetch={refetch} />
              )}
              {tab === 1 && <DocumentsTab beautician={b?.user} />}
              {tab === 2 && (
                <ServicesTab beautician={b?.user} refetch={refetch} />
              )}
              {tab === 3 && (
                <TimeslotsTab beautician={b?.user} refetch={refetch} />
              )}
              {tab === 4 && <BookingsTab beautician={b} refetch={refetch} />}
              {tab === 5 && <WalletTab beautician={b?.user} />}
              {/* Inventory tab no longer renders Inventory component here */}
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </DashboardLayout>
  );
}

export default UpdateBeautician;
